export const PROMOTION_MODAL_SEEN_KEY = "promotion-modal-seen";

export const PAYMENT_UPDATED_PARAM = "payment_updated";

export const UPDATED_MEMBERSHIP_ID_PARAM = "updated_membership";
